export function getDefaultChatModel(assistantId) {
  const id = String(assistantId || '');

  if (id === '3') {
    return 'gemini-3.5-flash-lite';
  }

  if (id === '0') {
    return 'gemini-3.5-flash-lite';
  }

  if (id === '2') {
    return 'gemini-3.5-flash-lite';
  }

  return 'gemini-3.5-flash-lite';
}
